import React, { useState } from 'react';
import SvgIcon from '@/pages/home/components/SvgIcon';
import LinkJump from '@gp/components/LinkJump';
import CommonBubble from '@home/components/CommonBubble';
import './index.scss';

const FavoriteProjectItem = (props: any) => {
  const { data = {}, handleCancelFollow, toDetails, isHyperlink } = props;
  const [showDelete, setShowDelete] = useState(false);

  return (
    <LinkJump url={isHyperlink ? toDetails?.(data, null, false) : ''}>
      <div
        className="dbg-favorite-projects-submenu-table-name"
        onMouseEnter={() => setShowDelete(true)}
        onMouseLeave={() => setShowDelete(false)}
        onClick={() => {
          toDetails?.(data, null, true);
        }}
      >
        <span className="dbg-favorite-projects-submenu-table-name-text">
          {data?.project_name || '-'}
        </span>
        {showDelete && (
          <CommonBubble
            content={'Remove from Favorite Project'}
            placement="right"
            key={data?.project_id}
            dark
          >
            <div
              className="dbg-favorite-projects-submenu-table-name-item-delete"
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleCancelFollow?.(data);
              }}
            >
              <SvgIcon type={'collect_cancel'} />
            </div>
          </CommonBubble>
        )}
      </div>
    </LinkJump>
  );
};

export default FavoriteProjectItem;
